import React, {useEffect, useState} from "react";
import MainLayout from "../MainLoyout/MainLayout";
import {
    Box, Chip, CircularProgress,
    Container,
    Drawer,
    FormControl,
    InputLabel,
    Paper,
    Select, Stack, styled,
    Table, TableBody, TableCell, tableCellClasses, TableContainer,
    TableHead,
    TableRow
} from "@mui/material";

import Title from "../Title";
import Success from "../Snackbar/Success";
import TextField from "@mui/material/TextField";
import MenuItem from "@mui/material/MenuItem";
import countryList from "react-select-country-list";
import Button from "@mui/material/Button";
import {Circle} from "@mui/icons-material";
import Api from "../../Services/Api";


const BillingInfoTable = ({type, reload}) => {


    const [rows, setRows] = React.useState([]);
    const [loading, setLoading] = React.useState(true);



    useEffect(() => {

       loadRows()

    }, [reload]);

    const loadRows = () => {
        if(type == "billing")
        {
            Api.indexBillingInfos().then(r => {setRows(r);  setLoading(false)})

        }
        else {
            Api.indexPaymentMethods().then(r => {setRows(r);  setLoading(false)})
        }
    }

    const markAsDefault = async (id) => {

        setLoading(true)


        if(type == "billing") {
           await Api.markAsDefaultBillingInfo({id: id})
        }
        else {
          await  Api.markAsDefaultPaymentMethod({id: id})
        }

        loadRows()

    }

    const deleteAction =  async (id) => {

        setLoading(true)

        if(type == "billing") {
            await Api.deleteBillingInfo({id: id})
        }
        else {
            await  Api.deletePaymentMethod({id: id})
        }

        loadRows()

    }


    const StyledTableCell = styled(TableCell)(({theme}) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.common.black,
            color: theme.palette.common.white,
        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
    }));


    return (

         !loading ?
        <TableContainer component={Paper} sx={{mt: 2}}>
            <Table sx={{minWidth: 650}} size="small" aria-label="simple table">
                <TableHead>
                    {type == "billing" ? <TableRow>


                            <StyledTableCell align="right">Company Name</StyledTableCell>
                            <StyledTableCell align="right">Tax Id</StyledTableCell>
                            <StyledTableCell align="right">Country</StyledTableCell>
                            <StyledTableCell align="right">Address</StyledTableCell>
                            <StyledTableCell align="right">Postal Code</StyledTableCell>


                            <StyledTableCell align="right">Actions</StyledTableCell>
                        </TableRow> :
                        <TableRow>

                            <StyledTableCell align="right">Bank Name</StyledTableCell>
                            <StyledTableCell align="right">Account Number</StyledTableCell>
                            <StyledTableCell align="right">IBAN</StyledTableCell>
                            <StyledTableCell align="right">SWIFT</StyledTableCell>
                            <StyledTableCell align="right">Currency</StyledTableCell>
                            <StyledTableCell align="right">Actions</StyledTableCell>

                        </TableRow>}
                </TableHead>
                <TableBody>
                    {rows?.map((item) => type == "billing" ? (

                        <TableRow
                            key={item.id}
                            sx={{'&:last-child td, &:last-child th': {border: 0}}}
                        >


                            <TableCell align="right">
                                {item.deleted_at && <Chip label="Deleted" color={"error"} size="small" variant={"outlined"}/>} {item.default == true && <Chip label="Default" color={"success"} size="small" variant={"outlined"}/>} {item.company_name}

                            </TableCell>
                            <TableCell align="right">
                                {item.tax_id}
                            </TableCell>
                            <TableCell align="right">
                                {item.country}
                            </TableCell>
                            <TableCell align="right">
                                {item.address}
                            </TableCell>
                            <TableCell align="right">
                                {item.postal_code}
                            </TableCell>
                            <TableCell align="right">
                                <Button variant={'outlined'} sx={{mr: 1}} size={"small"} disabled={item.default || item.deleted_at ? true:false} onClick={() => markAsDefault(item.id)}>Mark as Default</Button>
                                <Button variant={'outlined'}  color={"warning"} disabled={item.default ||  item.deleted_at ? true:false}  onClick={() => deleteAction(item.id)} size={"small"}>Delete</Button>
                            </TableCell>

                        </TableRow>
                    ):

                        <TableRow
                            key={item.id}
                            sx={{'&:last-child td, &:last-child th': {border: 0}}}
                        >


                            <TableCell align="right">
                                {item.deleted_at && <Chip label="Deleted" color={"error"} size="small" variant={"outlined"}/>} {item.default == true && <Chip label="Default" color={"success"} size="small" variant={"outlined"}/>} {item.bank_name}
                            </TableCell>
                            <TableCell align="right">
                                {item.account_number}
                            </TableCell>
                            <TableCell align="right">
                                {item.iban}
                            </TableCell>
                            <TableCell align="right">
                                {item.swift}
                            </TableCell>
                            <TableCell align="right">
                                {item.currency}
                            </TableCell>
                            <TableCell align="right">
                                <Button variant={'outlined'} size={"small"} sx={{mr: 1}} disabled={item.default ||  item.deleted_at ? true:false} onClick={() => markAsDefault(item.id)}>Mark as Default</Button>
                                <Button variant={'outlined'}  color={"warning"} disabled={item.default ||  item.deleted_at ? true:false}  onClick={() => deleteAction(item.id)} size={"small"}>Delete</Button>

                            </TableCell>

                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>:<Box sx={{width: '100%', minHeight: 100, p: 3, display: 'flex', alignItems: 'center', justifyContent: 'center'}}><CircularProgress  /></Box>

    )
}


export default BillingInfoTable